module.exports = __webpack_public_path__ + "img/QO_vG11hsqwkqUqi99zHF82WYT8.122152db.jpeg";